import React from "react";
import StarRating from "./StarRating";
import SlideshowGallery from "./SlideshowGallery";
import DeliveryInfo from "./DeliveryInfo";

const ProductDetailedCard = ({ product,images }) => {
  const phoneNumber = "917665363669"; // Replace with your WhatsApp number

  const message = `Hi!
I want to purchase this product.

Product: ${product.name}

Please share the ordering details.`;

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;
  return (
    <section className="py-2 lg:py-4 text-black">
      <div className="container px-5 mx-auto">
        <div className="w-full mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:h-auto">
            <SlideshowGallery images={images} />
          </div>
          <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
            <h1 className="text-2xl md:text-3sxl title-font font-medium mb-1">
              {product.name}
            </h1>
            <StarRating rating={5} />
            <span className="text-sm font-medium">12500+ bought in past month</span>
            
            <hr className="mt-2 mb-3" />
            <div className="flex items-center mb-2">
              <div class="space-y-1 text-sm font-medium">
                <div class="text-gray-500 ">Price:  <span className="line-through">{product.mrp}</span></div>
                <div class="text-red-700">{product.price} incl. GST</div>
                
                <div class="text-red-600">You Save: {product.savings} ({product.discount})</div>
                <div class="text-black font-medium">( Inclusive of all taxes )</div>
              </div>
            </div>
            
            <hr className="mt-2 mb-3" />
            <div className="my-2 flex flex-wrap gap-4">
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-green-600 px-4 py-2 rounded-xl font-bold text-lg hover:scale-105 transition flex items-center gap-2 border-2
                    hover:bg-green-600 hover:text-white 
                    "
                >
                   Buy Through WhatsApp
                </a>
            </div>
            <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
              {product.amazon && (
                <a
                  href={product.amazon}
                  target="_blank"
                  rel="noreferrer"
                  className="text-base lg:text-base py-2 px-4 border-2 border-pink-500 rounded-lg shadow-md transition duration-300
                  bg-white text-black font-bold text-center
                  hover:bg-pink-700 hover:text-white"
                >
                  Amazon
                </a>
              )}
              {product.flipkart && (
                <a
                  href={product.flipkart}
                  target="_blank"
                  rel="noreferrer"
                  className="text-base lg:text-base py-2 px-4 border-2 border-pink-500 rounded-lg shadow-md transition duration-300
                  bg-white text-black font-bold text-center
                  hover:bg-pink-700 hover:text-white"
                >
                  Flipkart
                </a>
              )}
              {product.meesho && (
                <a
                  href={product.meesho}
                  target="_blank"
                  rel="noreferrer"
                  className="text-base lg:text-base py-2 px-4 border-2 border-pink-500 rounded-lg shadow-md transition duration-300
                  bg-white text-black font-bold text-center
                  hover:bg-pink-700 hover:text-white"
                >
                  Meesho
                </a>
              )}
              {product.jiomart && (
                <a
                  href={product.jiomart}
                  target="_blank"
                  rel="noreferrer"
                  className="text-base lg:text-base py-2 px-4 border-2 border-pink-500 rounded-lg shadow-md transition duration-300
                  bg-white text-black font-bold text-center
                  hover:bg-pink-700 hover:text-white"
                >
                  Jiomart
                </a>
              )}
              {product.snapdeal && (
                <a
                  href={product.snapdeal}
                  target="_blank"
                  rel="noreferrer"
                  className="text-base lg:text-base py-2 px-4 border-2 border-pink-500 rounded-lg shadow-md transition duration-300
                  bg-white text-black font-bold text-center
                  hover:bg-pink-700 hover:text-white"
                >
                  Snapdeal
                </a>
              )}
              {product.Shopsy && (
                <a
                  href={product.Shopsy}
                  target="_blank"
                  rel="noreferrer"
                  className="text-base lg:text-base py-2 px-4 border-2 border-pink-500 rounded-lg shadow-md transition duration-300
                  bg-white text-black font-bold text-center
                  hover:bg-pink-700 hover:text-white"
                >
                  Shopsy
                </a>
              )}
            </div>
            <div class="flex items-center gap-6 py-4 mt-4 border-t border-b max-w-xl mx-auto">
                
                <div class="flex flex-col items-center text-center text-sm font-medium space-y-1">
                  <div class="bg-gray-100 rounded-full p-3">
                  <img src="/icons/product-return.png" alt="Not Returnable" class="w-6 h-6" />
                  </div>
                  <div>Easy<br/>Return</div>
                </div>
                <div class="flex flex-col items-center text-center  text-sm font-medium space-y-1">
                  <div class="bg-gray-100 rounded-full p-3">
                  <img src="/icons/fast.png" alt="Amazon Delivered" class="w-6 h-6" />
                  </div>
                  <div>Fast<br/>Delivery</div>
                </div>
                <div class="flex flex-col items-center text-center text-sm font-medium space-y-1">
                  <div class="bg-gray-100 rounded-full p-3">
                  <img src="/icons/free-delivery.png" alt="Free Delivery" class="w-6 h-6" />
                  </div>
                  <div>Free<br/>Delivery</div>
                </div>                
                <div class="flex flex-col items-center text-center text-sm font-medium space-y-1">
                  <div class="bg-gray-100 rounded-full p-3">
                  <img src="/icons/secure.png" alt="Secure Transaction" class="w-6 h-6" />
                  </div>
                  <div>Secure<br/>Transaction</div>
                </div>
              </div>
              <DeliveryInfo />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailedCard;
